export const getApplicationFaq = faqId =>
  fetch(
    `${
      process.env.REACT_APP_API_URL
    }/FaqCs?filter[where][showPageRExternalIdC]=${faqId}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  ).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/applicationFaqAPI.js